import { MenuProps, Menu } from '@mui/material';
import { styled } from '@mui/material/styles';

export const MenuStyled = styled(Menu)<MenuProps>(() => ({
  '&.MuiMenu-paper': {
    boxShadow: '0px 5px 5px -3px rgb(0 0 0 / 2%), 0px 8px 10px 1px rgb(0 0 0 / 2%), 0px 3px 14px 2px rgb(0 0 0 / 2%)',
  },
}));
